import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";

const NAV_MAP = {
  "Enhanced Insights": "enhancedPage",
  "Rep Performance": "repPage",
  "Other Insights": "othersPage",
  "Marketing Support Requests": "marketPage",
  "Growth Modeling": "growthModelingPage",
  "Pipeline Build & Sufficiency": "pipelineBuildandSuficencyPage",
  "Pipeline Velocity & Conversion": "pipelineVelocityandConversionPage",
  "Market Intel & Growth Levers": "marketIntelandGrowthLeversPage",
  "Sales Productivity": "salesProductivityPage",
  "Growth Science Insights": "growthScienceInsightsPage",
  "Custom Scorecards": "personalizedScorecardsPage",
  "Settings": "SettingsPage",
  "Product Performance": "productPage",
  "Product Insights": "productInsightsPage",
  "Customer Success": "customerSuccessPage",
  "Pipeline Progression": "pipelineProgressionPage",
};

const OpenPipelineMixDeepLinkComponent = () => {
  const history = useHistory();
  const user = useSelector((state) => state.app?.user);

  useEffect(() => {
    if (!user) return;
    const elements = user?.elements || [];
    const targetChartName = "Open Pipeline Mix Analysis";

    const groupObj = elements.find(
      (g) =>
        g.navItem !== "Favorites" &&
        g?.charts &&
        g.charts.some(
          (c) =>
            c?.Chart_Name?.trim().toLowerCase() ===
            targetChartName.trim().toLowerCase(),
        ),
    );
    const mixGroup = groupObj?.navItem;

    if (mixGroup && NAV_MAP[mixGroup]) {
      localStorage.setItem("skygeni-user-page", mixGroup);
      localStorage.setItem(
        `skygeni-user-${NAV_MAP[mixGroup]}`,
        targetChartName,
      );
      const targetKey = NAV_MAP[mixGroup];
      Object.values(NAV_MAP).forEach((key) => {
        if (key !== targetKey) {
          localStorage.removeItem(`skygeni-user-${key}`);
        }
      });
    } else {
      // Final Fallback
      localStorage.setItem("skygeni-user-page", "Home");
      localStorage.setItem("skygeni-user-enhancedPage", targetChartName);
      Object.values(NAV_MAP).forEach((key) => {
        if (key !== "enhancedPage") {
          localStorage.removeItem(`skygeni-user-${key}`);
        }
      });
    }

    history.push("/");
    window.location.reload();
  }, [user, history]);

  return <div style={{ margin: "1rem auto" }}>Loading...</div>;
};

export default OpenPipelineMixDeepLinkComponent;
